export const decodeJWT = (token: string | null): Record<string, any> | null => {
    if (!token) return null;

    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) new Error('Invalid token format');

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = JSON.parse(
            decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            )
        );

        return jsonPayload;
    } catch (error) {
        console.error('Failed to decode JWT:', error);
        return null;
    }
};